// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{font-size:16px !important}.PaperSelector-cls1__ccc6a3749729fdf13354{/*!*/}.PaperSelector-cls2__e5b83ca21a63924a120e{font-family:\"Roboto\",Helvetica,Arial,sans-serif;font-family:var(--type-font-family-sans-serif, \"Roboto\"),Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;font-size:13px;line-height:18px;color:#535366}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperSelector-cls1__ccc6a3749729fdf13354",
	"cls2": "PaperSelector-cls2__e5b83ca21a63924a120e PaperSelector-cls1__ccc6a3749729fdf13354"
};
export default ___CSS_LOADER_EXPORT___;
